import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/system/ai',
  component: Layout,
  redirect: '/system/ai/list',
  name: 'aiManagement',
  meta: {
    title: 'AI工具管理',
    icon: 'i-ep:cpu',
    menu: false,
  },
  children: [
    {
      path: 'list',
      name: 'aiList',
      component: () => import('@/views/system/ai/index.vue'),
      meta: {
        title: 'AI工具管理',
        icon: 'i-ep:cpu',
      },
    },
    {
      path: 'edit/:id',
      name: 'aiEdit',
      component: () => import('@/views/system/ai/edit.vue'),
      meta: {
        title: '编辑AI工具',
        icon: 'i-ep:edit',
        menu: false,
      },
    },
  ],
}

export default routes
